// extracted by mini-css-extract-plugin
module.exports = {"NumericRangeFeature":"vu_a bhb_b bhb_ux"};